"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useKeyboardButtonPressedFunc_1 = require("../useKeyboardButtonPressedFunc");
const react_1 = require("react");
const useMergeRefs_1 = __importDefault(require("../useMergeRefs"));
const test_ids_utils_1 = require("../../tests/test-ids-utils");
const constants_1 = require("../../tests/constants");
const function_utils_1 = require("../../utils/function-utils");
/**
 * Return props for adding clickable functionality to the element except for the styles and classNames
 */
function useClickableProps({ onClick = function_utils_1.NOOP, onMouseDown = function_utils_1.NOOP, onMouseEnter = function_utils_1.NOOP, onMouseLeave = function_utils_1.NOOP, disabled = false, id, dataTestId, role = "button", tabIndex = 0, ariaLabel, ariaHidden, ariaHasPopup, ariaExpanded }, ref) {
    const onKeyDown = (0, useKeyboardButtonPressedFunc_1.useKeyboardButtonPressedFunc)(onClick);
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    // Remove when ariaHasPopup is no longer a string
    const overrideAriaHasPopup = ariaHasPopup === undefined ? undefined : !!ariaHasPopup;
    return {
        ref: mergedRef,
        id,
        "data-testid": dataTestId || (0, test_ids_utils_1.getTestId)(constants_1.ComponentDefaultTestId.CLICKABLE, id),
        onClick: disabled ? undefined : onClick,
        onKeyDown: disabled ? undefined : onKeyDown,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        tabIndex: disabled ? -1 : Number(tabIndex),
        role,
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden,
        "aria-haspopup": overrideAriaHasPopup,
        "aria-expanded": ariaExpanded
    };
}
exports.default = useClickableProps;
